<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        Memorization Tool
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column" v-if="level == 0">
        <textarea class="textarea" v-model="sourceText" placeholder="Place your Holy Text here"></textarea>
      </div>

      <div class="column" v-if="level > 0">
        <span v-for="word in words" v-bind:key="word" :title="word.full">{{ word.abbreviated }}</span>
      </div>
    </div>

    <div class="columns">
      <div class="column" v-if="level == 0">
        <button type="button" class="button is-primary is-fullwidth" @click="makeItHarder()">
          Practice Memorization
        </button>
      </div>

      <div class="column is-half" v-if="level > 0">
        <button type="button" class="button is-primary is-fullwidth" @click="makeItEasier()">
          ⬅️ Easier
        </button>
      </div>

      <div class="column is-half" v-if="level > 0 && level < 9">
        <button type="button" class="button is-primary is-fullwidth" @click="makeItHarder()">
          Harder ➡
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import BackButton from '@/components/pages/BackButton'

export default {
  components: {
    BackButton
  },
  data () {
    return {
      sourceText: '',
      level: 0
    }
  },
  methods: {
    makeItHarder () {
      if (this.level === 9) {
        return
      }
      this.level += 1
    },
    makeItEasier () {
      if (this.level === 0) {
        return
      }
      this.level -= 1
    }
  },
  computed: {
    words () {
      const divisor = 10 - this.level
      return this.sourceText.replace(/\s{1,}/g, ' ').split(' ').map((word, index) => {
        let abbreviated = word
        const number = index + 1
        if (this.level > 0) {
          if (number % divisor === 0) {
            abbreviated = abbreviated[0] + '_'
          }
        }
        return {
          full: word,
          abbreviated: abbreviated + ' '
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/MemorizationToolPage.vue